import { useCallback } from 'react';
import { IssueStatus } from '@server/issues';
import { SweepNotificationVariant } from '../../reducers/notificationsReducer';
import useAiAgents from './useAiAgents';
import { useSweepNotifications } from '../notifications/useSweepNotifications';
import { AiAgent } from './aiAgentsConsts';
import { useSelector } from 'react-redux';
import { selectDefaultCreationCrmOrgId } from '../../reducers/userInfoReducer';
import useObjectTypesWithFetch from '../../hooks/useObjectTypesWithFetch';
import IssuesCard from '../issues/IssuesCard';

const AgentIssues = ({
  agent,
  onTextSelection,
  onExpandIssuesCard,
  tableInitialHeight,
}: {
  agent: AiAgent;
  onTextSelection?: (text: string | null) => void;
  onExpandIssuesCard?: (v: boolean) => void;
  tableInitialHeight?: number;
}) => {
  const { updateIssueStatus } = useAiAgents();
  const { addNotification } = useSweepNotifications();
  const crmOrgId = useSelector(selectDefaultCreationCrmOrgId);
  const { objectTypesByName } = useObjectTypesWithFetch({ crmOrgId: crmOrgId ?? '' });

  const objectType =
    'objectType' in agent.contextComponents ? agent.contextComponents.objectType : undefined;
  const objectLabel = objectType ? (objectTypesByName[objectType]?.label ?? objectType) : '';

  const handleUpdateIssueStatus = useCallback(
    async ({
      resourceName,
      issueId,
      status,
    }: {
      resourceName: string;
      issueId: string;
      status: IssueStatus;
    }) => {
      if (agent) {
        const updatedSuccessfully = await updateIssueStatus({
          agentId: agent.id,
          issueId,
          newStatus: status,
        });
        if (updatedSuccessfully) {
          addNotification({
            message: `${resourceName} is marked as ${status}`,
            variant: SweepNotificationVariant.Success,
          });
        }
      }
    },
    [agent, addNotification, updateIssueStatus],
  );

  return (
    <IssuesCard
      issues={agent.issues}
      objectLabel={objectLabel}
      isLoading={!!agent.isLoadingIssues}
      activeScan={agent.activeScan}
      onUpdateIssueStatus={handleUpdateIssueStatus}
      onTextSelection={onTextSelection}
      onCardExpandClick={onExpandIssuesCard}
      tableInitialHeight={tableInitialHeight}
    />
  );
};

export default AgentIssues;
